import React, { useEffect } from 'react';
import browserHistory from 'react-router/lib/browserHistory';
import { useDispatch, useSelector } from 'react-redux';
import * as PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { actions as providerProfileActions } from '../../../../redux/profiles/get-parent-provider';
import { selectProviderCalendarManageAccess } from '../../../../redux/profiles/selectors';
import { selectTargetProviderId } from '../../../../redux/context/selectors';
import { PROVIDER_CALENDAR } from '../../../../constants/routes';
import Button from '../../../Button';
import styles from './styles.styl';

function ScheduleButton({ intl: { formatMessage }, userId }) {
  const hasAccess = useSelector(selectProviderCalendarManageAccess);
  const providerId = useSelector(selectTargetProviderId);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(providerProfileActions.send({ id: userId }));
  }, [userId]);

  const redirectToCalendar = () => {
    const url = PROVIDER_CALENDAR.replace(':id', userId).replace(
      ':providerId',
      providerId,
    );
    browserHistory.push(url);
  };

  if (!hasAccess) return null;

  return (
    <div className={styles.root}>
      <Button
        className={styles.button}
        raised
        color="primary"
        onClick={redirectToCalendar}
      >
        {formatMessage({ id: 'calendar.manageSchedule' })}
      </Button>
    </div>
  );
}

ScheduleButton.propTypes = {
  intl: PropTypes.object,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default injectIntl(ScheduleButton);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/ScheduleButton/index.jsx